import { useState } from 'react';

export default function NotesListSidebar({ categories, selectedCategory, onSelectCategory }) {
    const [searchQuery, setSearchQuery] = useState('');

    const handleShare = () => {
        const tweet = encodeURIComponent(`local food spots to your weekend date plans.\n\neverything you need to know about delhi. \n \ncheck out: https://dilli.wiki`);
        const twitterIntentUrl = `https://twitter.com/intent/tweet?text=${tweet}`;
        window.open(twitterIntentUrl, '_blank');
    };

    // Filter categories based on search
    const filteredCategories = categories.filter(cat => 
        cat.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (cat.places && cat.places.some(place => 
            place.name.toLowerCase().includes(searchQuery.toLowerCase())
        ))
    );

    // Format date for display
    const formatDate = (date) => {
        const now = new Date();
        const noteDate = new Date(date);
        const diffTime = Math.abs(now - noteDate);
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        
        if (diffDays === 0) return 'Today';
        if (diffDays === 1) return 'Yesterday';
        if (diffDays < 7) return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][noteDate.getDay()];
        return noteDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    };

    // Get preview text for a category
    const getPreviewText = (category) => {
        if (!category.places || category.places.length === 0) {
            return 'No places yet';
        }
        const firstPlace = category.places[0];
        return `${firstPlace.name}${category.places.length > 1 ? `, ${category.places.length - 1} more...` : ''}`;
    };

    return (
        <aside className="w-[320px] bg-[#1C1C1E] flex flex-col border-r border-black/60 flex-shrink-0 z-10">
            <div className="h-14 px-4 flex items-center justify-between pt-2">
                <span className="text-[17px] font-bold text-white">dilli.wiki</span>
                <i 
                    className="ph ph-export text-[#FFB400] text-xl cursor-pointer hover:opacity-80 transition-opacity"
                    onClick={handleShare}
                ></i>
            </div>

            <div className="px-4 pb-3">
                <div className="bg-[#2C2C2E] h-9 rounded-[8px] flex items-center px-2 gap-2 text-[#8E8E93] focus-within:text-[#EBEBF5] focus-within:bg-[#3A3A3C] transition-colors">
                    <i className="ph ph-magnifying-glass text-lg"></i>
                    <input 
                        type="text" 
                        placeholder="Search" 
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="bg-transparent border-none outline-none text-[15px] placeholder-[#8E8E93] w-full text-white/90"
                    />
                    {searchQuery && (
                        <i 
                            className="ph ph-x text-lg cursor-pointer hover:text-white"
                            onClick={() => setSearchQuery('')}
                        ></i>
                    )}
                </div>
            </div>

            <div className="flex-1 overflow-y-auto">
                {categories.length > 0 && (
                    <>
                        <div className="px-5 py-1.5 text-[11px] font-semibold text-[#8E8E93] bg-[#1C1C1E] sticky top-0 uppercase tracking-wider backdrop-blur-sm bg-opacity-90 z-10">
                            Pinned
                        </div>

                        {/* Start Here pinned note */}
                        <div
                            onClick={() => onSelectCategory({ id: 'start-here', name: 'Start Here', isStartHere: true })}
                            className={`mx-3 mb-1 p-4 rounded-[10px] cursor-pointer relative group transition-all ${
                                selectedCategory?.id === 'start-here'
                                    ? 'bg-[#C69C08]/20 border border-[#FFB400]/20' 
                                    : 'bg-[#2C2C2E] border border-transparent hover:border-[#FFB400]/30'
                            }`}
                        >
                            <div className="flex justify-between items-start mb-0.5">
                                <h3 className="font-bold text-[15px] text-white truncate pr-2">Start Here</h3>
                                <i className="ph ph-push-pin-simple text-[#8E8E93] text-sm transform -rotate-45"></i>
                            </div>
                            <div className="flex gap-2 text-[14px]">
                                <span className="text-[#EBEBF5]/90 line-clamp-2 leading-snug">
                                    Want to romanticise Dilli on Instagram? This list should help. Stop getting lost on Google.
                                </span>
                            </div>
                            <div className="mt-2 text-[13px] text-[#8E8E93]">10:42 AM</div>
                        </div>

                        <div className="px-5 py-1.5 mt-2 text-[11px] font-semibold text-[#8E8E93] bg-[#1C1C1E] sticky top-0 uppercase tracking-wider backdrop-blur-sm bg-opacity-90 z-10">
                            Notes
                        </div>

                        {filteredCategories.map((category, index) => {
                            const isSelected = selectedCategory?.id === category.id;
                            const isPinned = false; // No categories are pinned, only Start Here
                            
                            return (
                                <div
                                    key={category.id}
                                    onClick={() => onSelectCategory(category)}
                                    className={`mx-3 mb-1 p-4 rounded-[10px] cursor-pointer relative group transition-all ${
                                        isSelected 
                                            ? 'bg-[#C69C08]/20 border border-[#FFB400]/20' 
                                            : isPinned
                                            ? 'bg-[#2C2C2E] border border-transparent hover:border-[#FFB400]/30'
                                            : 'hover:bg-[#2C2C2E] border-b border-[#38383A] last:border-0'
                                    }`}
                                >
                                    <h3 className="font-bold text-[15px] text-white mb-0.5">
                                        {category.emoji && <span className="mr-2">{category.emoji}</span>}
                                        {category.name}
                                    </h3>
                                    <div className="flex gap-2 text-[14px]">
                                        <span className="text-[#8E8E93] whitespace-nowrap">
                                            {formatDate(new Date())}
                                        </span>
                                        <span className="text-[#8E8E93] line-clamp-2 leading-snug">
                                            {getPreviewText(category)}
                                        </span>
                                    </div>
                                </div>
                            );
                        })}
                    </>
                )}
            </div>

            <div className="h-10 border-t border-black/50 flex items-center justify-center text-[11px] text-[#8E8E93]">
                9 Notes
            </div>
        </aside>
    );
}
